import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';

import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { LOGIN } from '../../graphql/user/mutation';

import useStyles from './styles';
import Box from '@material-ui/core/Box';
import { isAuthenticated, setAccessToken } from '../../services/localstorage';
import { isEmailValid as validateEmail } from '../../common/validator';
import { Redirect } from 'react-router-dom';
import {
  displaySnackBar,
  SnackVariableInterface,
} from '../../common/displaySnackbar';
import { ApiErrorCode } from '../../common/constants';
import {
  LoginAsAdmin,
  LoginAsAdminVariables,
} from '../../graphql/user/types/LoginAsAdmin';

const Authentication = () => {
  const snackBarData: SnackVariableInterface = {
    type: 'ERROR',
    message: '',
    isOpen: true,
  };
  const client = useApolloClient();

  const [input, setinput] = useState({ email: '', password: '' });

  const [loginMutation, { data }] = useMutation<
    LoginAsAdmin,
    LoginAsAdminVariables
  >(LOGIN, {
    onError: (error) => {
      if (error.graphQLErrors) {
        if (error.graphQLErrors.length) {
          const currentError = error.graphQLErrors[0];
          if (
            currentError.extensions &&
            currentError.extensions.code &&
            currentError.extensions.code === ApiErrorCode.WRONG_VALUE
          ) {
            if (currentError.extensions.key === 'password')
              snackBarData.message = 'Mot de passe incorrect.';
            else
              snackBarData.message = `${
                input.email ? 'Adresse email' : 'Numéro de téléphone'
              } incorrect.`;

            displaySnackBar(client, snackBarData);
          }
        }
      }
    },
  });

  const classes = useStyles();

  if (data && data.loginAsAdmin) {
    setAccessToken(data.loginAsAdmin);
    window.location.reload();
  }

  if (isAuthenticated()) return <Redirect {...{ to: '/enseignes' }} />;

  const isValid = () => {
    return (
      validateEmail((input?.email as string) || 'example@email.com') &&
      input.password !== ''
    );
  };

  const login = async () => {
    setinput({ ...input, email: input.email.trim() });
    loginMutation({ variables: { ...input } });
  };

  const onTextChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setinput({ ...input, [name]: value });
  };

  return (
    <Box className={classes.root}>
      <FormControl className={classes.formControl}>
        <TextField
          name="email"
          id="email"
          type="email"
          onChange={onTextChange}
          variant="outlined"
          label="Email"
          className={classes.input}
        />
        <TextField
          name="password"
          id="password"
          type="password"
          onChange={onTextChange}
          variant="outlined"
          label="Mot de passe"
          className={classes.input}
        />
        <Button
          variant="contained"
          onClick={login}
          disabled={!isValid()}
          className={classes.button}>
          Se connecter
        </Button>
      </FormControl>
    </Box>
  );
};

export default Authentication;
